import React from 'react';
import './Footer.css'

const Footer=()=>{

    return(

        <div className='footer'>
            <div className="container">
            <div className='left' >
                <p style={{fontSize:"15px"}}>
                    Our Hand picked daily deals are meant to save you a lot on your daily useful things.we work across various platform to carefully pick deals that are great value!
                </p>
            </div>

                <div className='right'>
               
                    <h5> <a  href='/'>Home</a></h5>
                    <h5><a  href='/blog'>Blog</a></h5>
                    <h5><a  href='/ContactUs'>Contact Us</a></h5>
                    <h5 style={{color:"#fff",fontSize:"20px"}}>Follow Us</h5>                
                    <ul>                        
                        <li><a style={{fontSize:"30px"}} href="https://www.facebook.com/profile.php?id=61550555985381" target='_blank' rel="noreferrer"><i className="fa fa-facebook" aria-hidden="true"></i> </a></li>
                        <li><a style={{fontSize:"30px"}}  href="https://www.facebook.com/groups/dinodealzandcouponz" target='_blank' rel="noreferrer"><i className="fa fa-group" aria-hidden="true"></i> </a></li>
                        <li><a style={{fontSize:"30px"}}  href="https://www.pinterest.com/Dinodealz/" target='_blank' rel="noreferrer"><i className='fa fa-pinterest'></i> </a></li>
                        <li><a style={{fontSize:"30px"}}  href="https://www.instagram.com/dinodealzandcouponz/" target='_blank' rel="noreferrer"><i className="fa fa-instagram" aria-hidden="true"></i> </a></li>
                    </ul>
                    <h5><a  href='/PrivacyPolicy'>Privacy Policy</a></h5>

                </div>
                <p className="disclosure">
                    As an Amazon Associate we earn from qualifying purchases. Prices and availability can change at any time.
                </p>
</div>
            </div>
      

    )

}
export default Footer